import { useState, useEffect } from 'react';
import { CandlestickData, IChartApi, ISeriesApi, MouseEventParams, Time } from 'lightweight-charts';

export const useCrosshair = (chart: IChartApi | undefined, candlestickSeries: ISeriesApi<'Candlestick'> | undefined) => {
  const [crosshairData, setCrosshairData] = useState<CandlestickData>();

  useEffect(() => {
    if (!chart || !candlestickSeries) return;

    const handleCrosshairMove = (param: MouseEventParams<Time>) => {
      if (!param?.time) return;
      const price = param.seriesData.get(candlestickSeries) as CandlestickData;
      if (price) {
        setCrosshairData({
          time: param.time,
          open: price.open,
          close: price.close,
          high: price.high,
          low: price.low,
        });
      }
    };

    chart.subscribeCrosshairMove(handleCrosshairMove);
    return () => chart.unsubscribeCrosshairMove(handleCrosshairMove);
  }, [chart, candlestickSeries]);

  return crosshairData;
};
